import React, {useEffect, useState} from 'react';
import './styles.scss';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import Header2 from '../../components/headers/header2';
import {Column, Row} from '../../components/layout';
import ModalTemplate from '../../components/modal';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../util/strings';
import {possibleAppointmentStatus} from '../../util/utility';
import Icon from '../../components/icon';
import {Icons} from '../../util/icons';
import AppButton from '../../components/app-button';
import AppointmentDetails from '../appointment-details';

interface AppointmentWarningPopupProps {
  showModal: boolean;
  setShowModal: any;
  labels: typeof strings.pt.appointments;
  buStyles: any;
  selectedAppointmentId: any;
  selectedAppointmentProviderId: string;
  status: string;
  setRefresh(value: any): void;
  handleStartAppointment(): void;
}

function AppointmentWarningPopup({
  showModal,
  setShowModal,
  labels,
  buStyles,
  selectedAppointmentId,
  selectedAppointmentProviderId,
  status,
  setRefresh,
  handleStartAppointment,
}: AppointmentWarningPopupProps) {
  const {PENDING, CANCELLED, DECLINED} = possibleAppointmentStatus;
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const renderWarningPopUp = () => {
    switch (status) {
      case PENDING:
        return (
          <ModalTemplate
            className="appointment-popup-modal"
            inputType="confirm"
            show={showModal}
            onHide={() => {
              setShowModal(false);
            }}
            onSubmit={() => {
              setShowModal(false);
            }}
            onCancel={() => {
              setShowModal(false);
            }}
            cross={true}
            hideFooter={true}>
            <Column className="appointment-popup-container">
              <Header2
                style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
                className="appointment-popup-container-title">
                {labels?.appointments_next_appointment}
              </Header2>
              <div>
                <Icon
                  width="24"
                  height="24"
                  className="appointment-popup-error-icon"
                  name={Icons.ALERT_PROBLEM}
                  color={colors.alertRed}
                />
              </div>
              <div className="appointment-error-text">
                {labels?.appointments_payment_pending}
              </div>
              <div className="appointment-error-text-2">
                {labels?.appointments_payment_pending_confirm}
              </div>
              <AppButton
                className="appointment-popup-button"
                variant="secondary"
                onClick={() => {
                  setShowModal(false);
                  setShowDetailsModal(true);
                }}>
                {labels?.appointments_understood}
              </AppButton>
            </Column>
          </ModalTemplate>
        );

      case CANCELLED:
      case DECLINED:
        return (
          <ModalTemplate
            className="appointment-popup-modal"
            inputType="confirm"
            show={showModal}
            onHide={() => {
              setShowModal(false);
            }}
            onSubmit={() => {
              setShowModal(false);
            }}
            onCancel={() => {
              setShowModal(false);
            }}
            cross={true}
            hideFooter={true}>
            <Column className="appointment-popup-container">
              <Header2
                style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
                className="appointment-popup-container-title">
                {labels?.appointments_cancelled_title}
              </Header2>
              <div>
                <Icon
                  width="24"
                  height="24"
                  className="appointment-popup-error-icon"
                  name={Icons.ALERT_PROBLEM}
                  color={colors.alertRed}
                />
              </div>
              <div className="appointment-error-text">
                {labels?.appointments_cancelled_error_text}
              </div>
              <div className="appointment-error-text-2">
                {labels?.appointments_cancelled_text}
              </div>
              <Row>
                <AppButton
                  className="appointment-popup-button"
                  variant="secondary"
                  onClick={() => {
                    setShowModal(false);
                  }}>
                  {labels?.appointments_understood}
                </AppButton>
              </Row>
            </Column>
          </ModalTemplate>
        );
    }
  };

  return (
    <div>
      {renderWarningPopUp()}
      <AppointmentDetails
        showDetailsModal={showDetailsModal}
        setShowDetailsModal={setShowDetailsModal}
        selectedAppointmentId={selectedAppointmentId}
        selectedAppointmentProviderId={selectedAppointmentProviderId}
        setRefresh={setRefresh}
        handleStartAppointment={handleStartAppointment}
      />
    </div>
  );
}

const mapStateToProps = ({selectedBu, strings, user, globalStyles}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.appointments,
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(AppointmentWarningPopup));
